import React, { useState } from "react";
import "./CalculatorInput.css";

export default function CalculatorInput({
  name,
  unit,
  value,
  onChangeVal,
  onHide,
  showTooltip,
}) {
  const [inputValue, setInputValue] = useState(value);

  const convertToWesternArabic = (persianNumber) => {
    const persianToWesternMap = {
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
    };

    return persianNumber.replace(
      /[۰-۹]/g,
      (match) => persianToWesternMap[match]
    );
  };

  const handleNumberInputChange = (e) => {
    const formattedInputValue = convertToWesternArabic(e.target.value);

    const numericRegex = /^\d*\.?\d{0,3}$/;

    if (numericRegex.test(formattedInputValue)) {
      if (formattedInputValue >= 0 && formattedInputValue <= 250) {
        setInputValue(formattedInputValue);
        onChangeVal(formattedInputValue);
      } else if (formattedInputValue < 0) {
        setInputValue(0);
        onChangeVal(0);
      } else if (formattedInputValue > 250) {
        setInputValue(250);
        onChangeVal(250);
      }
    } else {
      console.log("Invalid input: Please enter a valid number.");
    }
  };

  const handleRangeInputChange = (e) => {
    onChangeVal(e.target.value);
    setInputValue(e.target.value);
  };

  const handleTouchEnd = () => {
    onHide();
  };
  return (
    <div className="calculatorInputContainer centeredFlex">
      <div className="calculatorLabel centeredFlex">
        <p>{name}</p>
        <span> به {unit}</span>
      </div>
      <div className="rangeSliderContainer centeredFlex">
        <input
          type="range"
          className="rangeSlider"
          min={0}
          max={250}
          value={value}
          onChange={handleRangeInputChange}
          onTouchEnd={handleTouchEnd}
        />
        <div
          className="progressBar"
          style={{ width: `${(value / 250) * 100}%` }}
        />
        <span
          className="rangeTooltip centeredFlex"
          style={{
            left: `calc(${(value / 250) * 100}%)`,
            display: showTooltip ? "block" : "none",
          }}
        >
          {value}
          <div className="tooltipArrow"></div>
        </span>
      </div>
      <div className="calculatorValueWrapper">
        <input
          type="text"
          value={inputValue <= 250 ? inputValue : 250}
          onChange={handleNumberInputChange}
          className="calculatorValue"
        />
      </div>
    </div>
  );
}
